<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00062.installation.parampac.title' | translate"
      [description]="'P00062.installation.parampac.description' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="
        'P00062.installation.parampac.modeFonctionnementTemperature.title'
          | translate
      "
      [titleListe]="
        'P00062.installation.parampac.modeFonctionnementTemperature.value'
          | translate
      "
      [description]="
        'P00062.installation.parampac.modeFonctionnementTemperature.description'
          | translate
      "
      [value]="actionStack!.getValue('ppPModeFonctionnementTemperature')"
      [liste]="P00062ModeFonctionnementTemperature"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PACPOLY_Parametrage1,
          'ppPModeFonctionnementTemperature',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    <app-label-configuration
      [title]="
        'P00062.installation.parampac.modeFonctionnementRegulation.title'
          | translate
      "
      [titleListe]="
        'P00062.installation.parampac.modeFonctionnementRegulation.value'
          | translate
      "
      [information]="openEnSavoirPlus"
      [description]="
        'P00062.installation.parampac.modeFonctionnementRegulation.description'
          | translate
      "
      [value]="actionStack!.getValue('ppPModeFonctionnementRegulation')"
      [liste]="P00062ModeFonctionnementRegulation"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.PACPOLY_Parametrage1,
          'ppPModeFonctionnementRegulation',
          $event,
          null
        )
      "
    >
    </app-label-configuration>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
